import React from 'react';
import { createRoot } from 'react-dom/client';
import "bootstrap/dist/css/bootstrap.css"
import './styles/theme.css';
import './styles/global.css';
import Routes from './components/Routes'

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Routes />
  </React.StrictMode>
);
